<script>
import MixedGridSortSelect from '@phoenix/mixins/components/mixedGrid/MixedGridSortSelect';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: {
    PhxIcon,
  },

  mixins: [MixedGridSortSelect],
};
</script>

<template>
  <div class="field--select__wrapper field--select__wrapper-with-icon-end">
    <label for="select" class="sr-only">{{ $t('Accessibility.sortBy') }}</label>

    <select
      id="select"
      v-model="localValue"
      class="field field--select filters-bar__select-mobile"
      name="order"
      :aria-label="$t('Accessibility.sortBy')"
    >
      <option v-for="(option, val) in sortOptions" :key="option.id" class="text-black" :value="val">
        {{ $t(option.label) }}
      </option>
    </select>

    <phx-icon icon="chevron-10" class="icon--10 filters-bar__select-mobile" bidirectional />
  </div>
</template>
